import React from "react";
import { Nav, NavItem } from "reactstrap";
import { NavLink, useLocation } from "react-router-dom";

import homeNavIcon from "../assets/nav/home-active.svg";
import homeNavIconNotActive from "../assets/nav/home-not-active.svg";
import profileNavIcon from "../assets/nav/profile-active.svg";
import profileNavIconNotActive from "../assets/nav/profile-not-active.svg";

const tabs = [
  {
    route: "/",
    icon: homeNavIcon,
    iconNotActive: homeNavIconNotActive,
    label: "Beranda",
  },
  {
    route: "/report",
    icon: profileNavIcon,
    iconNotActive: profileNavIconNotActive,
    label: "Laporan",
  },
];

const Navigation = (props) => {
  const location = useLocation();

  return (
    <div>
      {/* Bottom Tab Navigator*/}
      <nav className="navbar fixed-bottom navbar-light" role="navigation">
        <Nav className="w-100">
          <div className=" d-flex flex-row justify-content-around w-100">
            {tabs.map((tab, index) => (
              <NavItem key={`tab-${index}`}>
                <NavLink to={tab.route} className="nav-link">
                  <div className="text-center">
                    <img
                      src={
                        location.pathname === tab.route
                          ? tab.icon
                          : tab.iconNotActive
                      }
                      alt={tab.label}
                      className="mb-1"
                      style={{ width: "18px", height: "auto" }}
                    />
                    <h6
                      style={{
                        fontSize: "0.8em",
                        color:
                          location.pathname === tab.route
                            ? "var(--primary-color)"
                            : "gray",
                      }}
                    >
                      {tab.label}
                    </h6>
                  </div>
                </NavLink>
              </NavItem>
            ))}
          </div>
        </Nav>
      </nav>
    </div>
  );
};

export default Navigation;
